import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import ScholarshipsPage from './components/ScholarshipsPage';
import ScholarshipApplication from './components/ScholarshipApplication';
import DonatePage from './components/DonatePage';
import DonateSuccessPage from './components/DonateSuccessPage';
import ContactPage from './components/ContactPage';
import GLOPage from './components/GLOPage';
import Navigation from './components/Navigation';
import NewsletterSignup from './components/NewsletterSignup';
import Footer from './components/Footer';

// ScrollToTop component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/scholarships" element={<ScholarshipsPage />} />
          <Route path="/scholarships/apply/:type" element={<ScholarshipApplication />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/donate/success" element={<DonateSuccessPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/glo" element={<GLOPage />} />
        </Routes>
        <NewsletterSignup />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
